import { usingGet, usingPost } from '@ocean/api'
import { BASE_API_SCHEDULE_PATH } from 'modules/virtualClassrooms/common/helpers'
import {
  UpdateScheduleRecordingsParams,
  SaveVirtualEventScheduleAttendanceParams,
} from 'modules/virtualClassrooms/student/PresenterScheduleDetails/types'

export const getScheduleDetailsForPresenter = (scheduleId: Guid) =>
  usingGet(`${BASE_API_SCHEDULE_PATH}/${scheduleId}/presenter`, {
    useProxy: true,
  })

export const updateScheduleRecordings = (params: UpdateScheduleRecordingsParams) =>
  usingPost(`${BASE_API_SCHEDULE_PATH}/updateDownloadRecordingsSetting`, params, {
    useProxy: true,
  })

export const saveVirtualEventScheduleAttendance = (
  params: SaveVirtualEventScheduleAttendanceParams
) => usingPost('VirtualEvents/SaveVirtualEventScheduleAttendance', params)

export const startVirtualEvent = (scheduleId: Guid) =>
  usingPost(`${BASE_API_SCHEDULE_PATH}/join`, { scheduleId }, { useProxy: true })

export const prepareVirtualEvent = (scheduleId: Guid) =>
  usingPost(`${BASE_API_SCHEDULE_PATH}/prepare`, { scheduleId }, { useProxy: true })

export const endVirtualEvent = (scheduleId: Guid) =>
  usingPost(`${BASE_API_SCHEDULE_PATH}/end`, { scheduleId }, { useProxy: true })

export const sendEndEventNotification = (scheduleId: Guid) =>
  usingPost(
    `${BASE_API_SCHEDULE_PATH}/sendEndEventNotification`,
    { scheduleId },
    { useProxy: true }
  )
